import { toast } from "react-toastify";

export const stringOperation = (string) => {
  return String(string)?.toLowerCase().split(" ").join("-");
};
//date formatter
export const DateFormatter = (string) => {
  const date = new Date(string).toLocaleDateString("en-US");
  return date;
};

// close pop
export const closePop = () => {
  const pop = document.querySelector("#pop");
  pop?.classList.toggle("hide");
};
// open modal
export const openPop = () => {
  const pop = document.querySelector("#pop");
  if (pop?.classList.contains("hide")) {
    pop.classList.remove("hide");
  }
};
// alerts messages
export const alertMsg = (msg, success, ar = "ar") => {
  if (success && ar === "ar")
    toast.success(msg, {
      position: toast.POSITION.BOTTOM_LEFT,
    });
  else if (!success && ar === "ar")
    toast.error(msg, {
      position: toast.POSITION.BOTTOM_LEFT,
    });
  else if (success && ar !== "ar")
    toast.success(msg, {
      position: toast.POSITION.BOTTOM_RIGHT,
    });
  else if (!success && ar !== "ar")
    toast.error(msg, {
      position: toast.POSITION.BOTTOM_RIGHT,
    });
};
